import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem, Divider } from 'rc-menu'
import 'rc-dropdown/assets/index.css'
import ReactTooltip from 'react-tooltip'

import { iconForTaskStatus } from '_utils/icon'
import Icon from '_components/icon'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const mapStateToProps = ({ counter, currentTask, settings }) => ({
  counter,
  currentTask,
  settings,
})

class Card extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    startedAt: PropTypes.string.isRequired,
    playCard: PropTypes.func.isRequired,
    viewDetailsCard: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  onPlayClick = () => {
    const { playCard, name } = this.props
    playCard(name)
  }

  onDetailsClick = () => {
    const { viewDetailsCard, id } = this.props
    viewDetailsCard(id)
  }

  renderStatus = () => {
    const { status } = this.props
    const iconName = iconForTaskStatus(status)

    return (
      <Icon
        className={classnames(styles.icon)}
        onClick={this.onCheckboxClick}
        type={iconName}
        isButton={false}
      />
    )
  }

  render() {
    const { name, startedAt } = this.props
    const borderColor = 'rgba(150,150,150,0.8)'
    return (
      <div className={classnames(styles.card)} style={{ border: `${borderColor} 3px solid` }}>
        {this.renderStatus()}
        <div
          data-tip
          data-for={`${name}-tip`}
          onClick={this.onDetailsClick}
          className={classnames(styles.name)}
        >
          {name}
          <ReactTooltip id={`${name}-tip`}>{name}</ReactTooltip>
        </div>
        <div onClick={this.onDetailsClick} className={classnames(styles.name)}>
          {Moment(startedAt).format('MM-DD-YYYY')}
        </div>
        <i onClick={this.onPlayClick} className={classnames('hmm-icon-play', styles.icon)} />
      </div>
    )
  }
}

export default connectRedux(mapStateToProps, null)(Card)



// WEBPACK FOOTER //
// ./src/views/search/log-card/index.js